/**
 * Timing the web chat's two halves have to agree on.
 *
 * Shared rather than restated because the browser cannot observe the server's
 * pacing: it has to know the same number to draw the right thing, and two
 * copies of it drift the first time one is tuned.
 */

/**
 * How long the agent waits before answering a web turn.
 *
 * Long enough to let somebody finish a thought spread over several messages --
 * "hey", "quick question", then the actual question -- so they get one answer
 * to all of it rather than an answer to the first line while they are still
 * typing the third. Below Linq's 5-8s, because a browser reply is read
 * immediately and a text is not.
 */
export const WEB_CHAT_DEBOUNCE_MS = 3_000;
